import { Icon } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import React from 'react'

const EmptyImage = props => (
  <div style={{ padding: 5 }}>
    <Icon icon={IconNames.MEDIA} iconSize={40} color="#ddd" {...props} />
  </div>
)

export { EmptyImage }
export default React.memo(EmptyImage)
